import {
  Grid,
  RACButton,
  RACModalCard,
  Typography,
} from '@rentacenter/racstrap';
import { ReactComponent as AlertIcon } from '../Icons/Error.svg';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { InventoryStyles } from '../../../JsStyles/InventoryStyles';

export default function ErrorPopup(props?: any) {
  const classes = InventoryStyles();
  const history = useHistory();
  const navigate = props && props?.navigateBack ? true : false;
  const [showPopup, setShowPopup] = useState<boolean>(true);
  return (
    <RACModalCard
      isOpen={showPopup}
      closeIcon={false}
      maxWidth="xs"
      borderRadius="25px !important"
    >
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.centerAlign}>
          <AlertIcon></AlertIcon>
          <Typography variant="h6" className={`  ${classes.mt2}`}>
            {props?.message ? props.message : 'Something went wrong'}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.centerAlign}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              navigate ? history.goBack() : props.setFunction(false);
              setShowPopup(false);
            }}
          >
            OK
          </RACButton>
        </Grid>
      </div>
    </RACModalCard>
  );
}
